<template>
  <div v-shortkey.once="['esc']" @shortkey="overlay.overlay = false">
    <v-row class="grey darken-4 mx-0">
      <v-col cols="6" sm="3" md="2" lg="2">
        <c-select
          :rotulo="$t('labels.opcoesBusca')"
          :label="$t('labels.opcoesBusca')"
          itemText="label"
          itemValue="value"
          :lista="translatedOptions"
          :item.sync="searchFields.option"
          v-model="searchFields.option"
          dense
          dark
          outlined
          auto-select-first
          :disable-lookup="true"
          :clearable="false"
          @input="changeValue($event)"
          @clear="changeValue($event)"
        />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <div>
          <c-select
            :rotulo="$t('labels.fabricantes')"
            itemText="text"
            itemValue="value"
            :lista="cbManufacturerList"
            v-model="searchFields.fabricante"
            @input="changeFabricante"
          />
          <!-- <v-combobox dark :items="cbManufacturerList" dense hint="Fabricantes" persistent-hint @change="changeFabricante($event)" :value="itemQuery.fabricante"/> -->
        </div>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <div>
          <c-select
            :rotulo="$t('labels.grupos')"
            itemText="text"
            itemValue="value"
            :lista="cbItemGroupList"
            v-model="searchFields.grupo"
            @input="changeGrupo"
          />
          <!-- <v-combobox dark :items="cbItemGroupList" dense hint="Grupos" persistent-hint @change="changeGrupo($event)" :value="itemQuery.grupo"/> -->
        </div>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <div>
          <c-select
            :rotulo="$t('labels.marcas')"
            itemText="text"
            itemValue="value"
            :lista="cbBrandList"
            v-model="searchFields.marca"
            @input="changeMarca"
          />
          <!-- <v-combobox dark :items="cbBrandList" dense hint="Marcas" persistent-hint @change="changeMarca($event)" :value="itemQuery.marca"/> -->
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-text-field
          class="text-caption"
          :label="$t('labels.termoBusca')"
          :placeholder="
            $t('placeholders.busca', { campo: searchFields.option.label })
          "
          outlined
          dense
          dark
          :maxlength="searchFields.option.maxLength"
          v-model="searchFields.text"
        />
      </v-col>
    </v-row>
    <c-index-buttons
      @search="sendSearch()"
      @register="openRegister()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <!-- {{avaiableHeaders}} -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          class="elevation-1"
          dense
          dark
          hide-default-footer
          :headers="tableHeaderSelected"
          :items="itemList"
          :loading="loadingItems"
          :items-per-page="pagination.perPage"
        >
          <template v-slot:item.PRECOVAREJO="{ item }">
            {{ formatCurrency(0, item.PRECOVAREJO[currenciesList[0].cifrao]) }}
          </template>
          <template v-slot:item.PRECOATACADO="{ item }">
            {{ formatCurrency(0, item.PRECOATACADO[currenciesList[0].cifrao]) }}
          </template>
          <template v-slot:item.SALDOITEM="{ item }">
            {{
              ['KG', 'MT'].lastIndexOf(item.UM) >= 0
                ? formatDecimal(item.SALDOITEM, 2, 2)
                : formatDecimal(item.SALDOITEM, 0, 0)
            }}
          </template>
          <template v-slot:item.imagens.image_name="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-if="item.imagens">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    x-small
                    @click="toogleOverlay(item)"
                  >
                    <v-icon color="blue">mdi-image-outline</v-icon>
                  </v-btn>
                </span>
                <span v-else>
                  <v-btn v-on="on" v-bind="attrs" x-small>
                    <span class="red--text">X</span>
                  </v-btn>
                </span>
              </template>
              <span v-if="item.imagens">{{ $t('tabelas.verImagem') }}</span>
              <span v-else>{{ $t('tabelas.semImagem') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          :length="pagination.lastPage"
          total-visible="9"
          v-model="pagination.currentPage"
          @input="changePage($event)"
          :disabled="loadingItems"
        >
        </v-pagination>
      </v-col>
    </v-row>
    <!-- Imagem overlay Component-->
    <overlayItem
      :isVisible="overlay.overlay"
      :isAbsolute="overlay.absolute"
      :imagesList="imagesList"
      :item="overlay.item"
      :especificacoes="overlay.especificacoes"
      :opacity="0.8"
      v-model="overlay.model"
      @closeOverlay="closeOverlay"
    />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>
<script>
import { itemMixin } from '@/mixins/object/item/ItemMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'
import cSelect from '@/components/shared/base-input/BaseSelect'
import overlayItem from '@/components/shared/base-overlay/BaseOverlay'
import cIndexButtons from '@/components/shared/base-buttons/IndexButtons'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  mixins: [itemMixin, tableMixin, currencyMixin, headerMixin],
  components: {
    cSelect,
    cIndexButtons,
    overlayItem,
  },
  data: () => {
    return {
      headerName: 'itemIndex',
      tableHeaderAvaiable: [
        { label: 'codigo', text: 'Código', value: 'CODIGO', show: true },
        {
          label: 'descricao',
          text: 'Descrição',
          value: 'DESCRICAO',
          show: true,
        },
        {
          label: 'imagem',
          text: 'Imagem',
          value: 'imagens.image_name',
          show: true,
        },
        { text: 'UM', value: 'UM', show: true },
        { text: 'Marca', value: 'MARCA', show: true },
        { text: 'Grupo', value: 'NOMEGRUPO', show: true },
        {
          text: 'Preço Varejo',
          value: 'PRECOVAREJO',
          show: true,
        },
        {
          text: 'Preço Atacado',
          value: 'PRECOATACADO',
          show: true,
        },
        { text: 'Saldo', value: 'SALDOITEM', align: 'center', show: true },
      ],
      overlay: {
        overlay: false,
        cycle: false,
        absolute: false,
        color: 'dark',
        model: 0,
        especificacoes: '',
        item: {},
      },
      imagesList: [],
      textLabel: 'Código',
      searchFields: {
        text: '',
        fabricante: '',
        grupo: '',
        marca: '',
        option: { label: 'Código', value: 'codigo', maxLength: 8 },
      },
      options: [
        { label: 'Código', value: 'codigo', maxLength: 8 },
        { label: 'Descrição', value: 'descricao', maxLength: 78 },
        { label: 'Fabricante', value: 'fabricante', maxLength: 78 },
        { label: 'Grupo', value: 'grupo', maxLength: 78 },
        { label: 'N.C.M', value: 'ncm', maxLength: 12 },
      ],
    }
  },
  computed: {
    ...mapGetters({
      cbBrandList: 'brandModule/getCbList',
      cbManufacturerList: 'manufacturerModule/getCbList',
      cbItemGroupList: 'itemGroupModule/getComboBoxList',
      currenciesList: 'systemModule/getSystemCurrencies',
    }),
    ...mapState('itemModule', ['itemList', 'pagination', 'loadingItems']),
    ...mapState('currencyModule', ['currency']),
    translatedOptions() {
      return this.options.map((element) => {
        if (this.$te(`labels.${element.value}`))
          element.label = this.$t(`labels.${element.value}`)

        return element
      })
    },
  },
  methods: {
    ...mapActions({
      getBrandsAPI: 'brandModule/getBrands',
      getManufacturersAPI: 'manufacturerModule/getManufacturers',
      getItemsGroup: 'itemGroupModule/getItemsGroup',
      requestItemsAPI: 'itemModule/getItens',
      getcurrencyAPI: 'currencyModule/getCurrency',
    }),
    openRegister() {
      this.$toasted.info(
        this.$t('messages.cannotRegister', {
          nome: this.$tc('labels.produto', 2),
        })
      )
    },
    closeOverlay() {
      this.overlay.overlay = false
    },
    toogleOverlay(item = null) {
      const imagensName = ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
      this.imagesList = []
      this.overlay.model = 0
      this.overlay.item = item
      if (item && item.imagens) {
        this.overlay.overlay = !this.overlay.overlay
        this.overlay.especificacoes = item.imagens.especificacoes
        imagensName.forEach((key) => {
          if (item.imagens.images_base64[key]) {
            let path =
              'data:image/jpg;base64,' + item.imagens.images_base64[key]
            this.imagesList.push(path)
          }
        })
      }
    },
    changeValue(item) {
      if (item) this.textLabel = item.label
      else {
        this.textLabel = this.translatedOptions[0].label
        this.searchFields.option = this.translatedOptions[0]
      }
      this.searchFields.text = ''
    },
    changePage(page) {
      if (page) this.itemQuery.page = page
      else this.itemQuery.page = this.pagination.currentPage
      this.sendSearch()
    },
    changeFabricante(item) {
      this.itemQuery.page = 1
      if (item) this.itemQuery.fabricante = item.value
      else this.itemQuery.fabricante = ''
    },
    changeMarca(item) {
      this.itemQuery.page = 1
      if (item) this.itemQuery.marca = item.value
      else this.itemQuery.marca = ''
    },
    changeGrupo(item) {
      this.itemQuery.page = 1
      if (item) this.itemQuery.grupo = item.value
      else this.itemQuery.grupo = ''
    },
    async sendSearch() {
      if (!this.loadingItems) {
        try {
          let searchText = this.searchFields.text ?? ''
          let key = this.searchFields.option.value
          if (searchText.trim().length > 0 && key) {
            this.itemQuery[key] = searchText
          } else {
            this.itemQuery.descricao = ''
            this.itemQuery.codigo = ''
            this.itemQuery.ncm = ''
          }
          if (this.searchFields.grupo)
            this.itemQuery.grupo = this.searchFields.grupo.value
          else this.itemQuery.grupo = ''
          if (this.searchFields.marca)
            this.itemQuery.marca = this.searchFields.marca.value
          else this.itemQuery.marca = ''
          if (this.searchFields.fabricante)
            this.itemQuery.fabricante = this.searchFields.fabricante.value
          else this.itemQuery.fabricante = ''
          await this.requestItemsAPI({ query: this.itemQuery })

          this.cleanSearch()
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        }
      }
    },
    cleanSearch() {
      Object.keys(this.itemQuery).forEach((key) => {
        if (key != 'todos' && key != 'page') this.itemQuery[key] = ''
      })
    },
    async getGroups() {
      try {
        await this.getItemsGroup({ todos: 'S' })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  async mounted() {
    try {
      if (this.cbBrandList.length <= 0) await this.getBrandsAPI({ todos: 'S' })
      if (this.cbManufacturerList.length <= 0)
        await this.getManufacturersAPI({ todos: 'S' })
      if (this.cbItemGroupList.length <= 0) await this.getGroups()
      if (this.currency.length == 0) await this.getcurrencyAPI({ page: 1 })
    } catch (error) {
      this.$toasted.error(error, { duration: null })
    }
    this.sendSearch()
    this.mountHeader()
  },
}
</script>
<style></style>
